module.exports = __webpack_public_path__ + "static/media/prop-6@2x.42fc370a.webp";